import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=68d83270&scoped=true&"
import script from "./customerList.vue?vue&type=script&lang=js&"
export * from "./customerList.vue?vue&type=script&lang=js&"
import style0 from "./customerList.vue?vue&type=style&index=0&id=68d83270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d83270",
  null
  
)

export default component.exports